import { render, staticRenderFns } from "./Fluxo.vue?vue&type=template&id=75f3d71a&scoped=true"
import script from "./Fluxo.vue?vue&type=script&lang=js"
export * from "./Fluxo.vue?vue&type=script&lang=js"
import style0 from "./Fluxo.vue?vue&type=style&index=0&id=75f3d71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f3d71a",
  null
  
)

export default component.exports